export default __webpack_public_path__ + "static/media/06.c29d8bfe.jpg";